import React from 'react';
import { Menu, ShoppingBag } from 'lucide-react';
export function Header() {
  return <header className="w-full sticky top-0 z-50 bg-brand-cream/90 backdrop-blur-md border-b border-brand-gold/20" data-id="element-61">
      <div className="bg-brand-burgundy text-brand-cream text-center py-2 px-4 text-sm font-medium tracking-wide" data-id="element-62">
        Envío del PDF inmediato + bonos de regalo 🤍
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-63">
        <button className="p-2 -ml-2 text-brand-burgundy hover:bg-brand-rose-light/20 rounded-full transition-colors lg:hidden" aria-label="Menú" data-id="element-64">
          <Menu className="w-5 h-5" data-id="element-65" />
        </button>

        <div className="font-serif text-xl md:text-2xl font-semibold text-brand-burgundy tracking-wide" data-id="element-66">
          María Andrea López
        </div>

        <nav className="hidden lg:flex items-center gap-8 text-sm font-medium text-gray-700" data-id="element-67">
          <a href="#el-metodo" className="hover:text-brand-burgundy transition-colors" data-id="element-68">
            El Método
          </a>
          <a href="#que-incluye" className="hover:text-brand-burgundy transition-colors" data-id="element-69">
            Qué Incluye
          </a>
          <a href="#testimonios" className="hover:text-brand-burgundy transition-colors" data-id="element-70">
            Testimonios
          </a>
          <a href="#faq" className="hover:text-brand-burgundy transition-colors" data-id="element-71">
            FAQ
          </a>
        </nav>

        <button className="p-2 -mr-2 text-brand-burgundy hover:bg-brand-rose-light/20 rounded-full transition-colors" aria-label="Carrito" data-id="element-72">
          <ShoppingBag className="w-5 h-5" data-id="element-73" />
        </button>
      </div>
    </header>;
}